import { render, staticRenderFns } from "./BannerWithImageAndText.vue?vue&type=template&id=812640ec&scoped=true&lang=pug&"
import script from "./BannerWithImageAndText.vue?vue&type=script&lang=ts&"
export * from "./BannerWithImageAndText.vue?vue&type=script&lang=ts&"
import style0 from "./BannerWithImageAndText.vue?vue&type=style&index=0&id=812640ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812640ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('812640ec')) {
      api.createRecord('812640ec', component.options)
    } else {
      api.reload('812640ec', component.options)
    }
    module.hot.accept("./BannerWithImageAndText.vue?vue&type=template&id=812640ec&scoped=true&lang=pug&", function () {
      api.rerender('812640ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/BannerWithImageAndText.vue"
export default component.exports